// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { FiArrowLeft, FiHeart, FiShare2, FiPhone, FiMail, FiMapPin, FiEye, FiMaximize, FiVideo, FiX, FiBarChart2, FiUsers, FiExternalLink } from 'react-icons/fi';
// import { FaWhatsapp, FaFacebook, FaTwitter, FaBed } from 'react-icons/fa';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';
// import { announcementAPI } from '../../services/api';
// import { useAuth } from '../../context/AuthContext';

// // Fix Leaflet marker icons
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

// const AnnouncementDetailPage = () => {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const { user } = useAuth();
  
//   const [announcement, setAnnouncement] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isFavorite, setIsFavorite] = useState(false);
//   const [showVirtualTour, setShowVirtualTour] = useState(false);
//   const [showContactForm, setShowContactForm] = useState(false);
//   const [contactForm, setContactForm] = useState({ name: '', email: '', phone: '', message: '' });
//   const [contactSent, setContactSent] = useState(false);
//   const [stats, setStats] = useState(null);
//   const [recommendations, setRecommendations] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(0);
//   const [showShareMenu, setShowShareMenu] = useState(false);
  
//   const isAgent = ['super-admin', 'admin-agence', 'agent', 'comptable'].includes(user?.role_slug || user?.role);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const { data } = await announcementAPI.getBySlug(slug);
//         setAnnouncement(data);
        
//         // SEO
//         document.title = data.seo_title || data.title;
//         let meta = document.querySelector('meta[name="description"]');
//         if (!meta) { 
//           meta = document.createElement('meta'); 
//           meta.name = 'description'; 
//           document.head.appendChild(meta); 
//         }
//         meta.content = data.seo_description || data.description?.substring(0, 160) || '';
        
//         // Charger stats et recommandations
//         if (isAgent) {
//           announcementAPI.getStats(data.id).then(r => setStats(r.data)).catch(() => {});
//         }
//         announcementAPI.getRecommendations(data.id).then(r => setRecommendations(r.data || [])).catch(() => {});
//       } catch (e) {
//         navigate('/announcements');
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, [slug, navigate, isAgent]);

//   const handleToggleFavorite = async () => {
//     try {
//       if (isFavorite) { 
//         await announcementAPI.removeFavorite(announcement.id); 
//         setIsFavorite(false); 
//       } else { 
//         await announcementAPI.addFavorite(announcement.id); 
//         setIsFavorite(true); 
//       }
//     } catch (e) {}
//   };

//   const handleShare = async (platform) => {
//     const url = window.location.href;
//     const text = `${announcement.title} - ${parseInt(announcement.price || 0).toLocaleString()} XOF - ${announcement.city}`;
//     await announcementAPI.incrementShares(announcement.id).catch(() => {});
    
//     const urls = {
//       whatsapp: `https://wa.me/?text=${encodeURIComponent(text + '\n' + url)}`,
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
//       twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
//     };
    
//     if (platform === 'copy') { 
//       navigator.clipboard.writeText(url); 
//       alert('Lien copié !'); 
//     } else {
//       window.open(urls[platform], '_blank');
//     }
//     setShowShareMenu(false);
//   };

//   const handleContact = async (e) => {
//     e.preventDefault();
//     try {
//       const { data } = await announcementAPI.addContact(announcement.id, contactForm);
//       setContactSent(true);
//       // Gérer la notification côté visiteur (toast)
//       if (data.notifications && data.notifications.length > 0) {
//         alert("L'agence a été notifiée de votre demande en temps réel !");
//       }
//     } catch (e) { 
//       alert("Erreur lors de l'envoi"); 
//     }
//   };

//   if (loading) {
//     return <div className="container" style={{ padding: '40px', textAlign: 'center' }}>Chargement...</div>;
//   }

//   if (!announcement) {
//     return <div className="container" style={{ padding: '40px', textAlign: 'center' }}>Annonce non trouvée</div>;
//   }

//   return (
//     <div className="container" style={{ padding: '16px 0' }}>
//       {/* Header */}
//       <div className="page-header">
//         <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
//           <button className="btn btn-secondary btn-sm" onClick={() => navigate('/announcements')}>
//             <FiArrowLeft /> Retour
//           </button>
//           <h1 style={{ margin: 0 }}>{announcement.title}</h1>
//           {announcement.is_featured && <span className="badge badge-warning">Vedette</span>}
//           <span className={`badge badge-${announcement.status === 'published' ? 'success' : 'secondary'}`}>
//             {announcement.status === 'published' ? 'Publié' : announcement.status}
//           </span>
//         </div>
//         <div style={{ display: 'flex', gap: 8 }}>
//           <button className={`btn btn-sm ${isFavorite ? 'btn-danger' : 'btn-secondary'}`} onClick={handleToggleFavorite}>
//             <FiHeart /> {isFavorite ? 'Favori' : 'Ajouter aux favoris'}
//           </button>
//           <button className="btn btn-secondary btn-sm" style={{ color: '#25D366', borderColor: '#25D366' }} onClick={() => handleShare('whatsapp')}>
//             <FaWhatsapp /> Partager sur WhatsApp
//           </button>
//           <div style={{ position: 'relative' }}>
//             <button className="btn btn-secondary btn-sm" onClick={() => setShowShareMenu(!showShareMenu)}>
//               <FiShare2 /> Plus de partages
//             </button>
//             {showShareMenu && (
//               <div style={{ 
//                 position: 'absolute', 
//                 right: 0, 
//                 top: '100%', 
//                 background: 'var(--bg-card)', 
//                 border: '1px solid var(--border)', 
//                 borderRadius: 8, 
//                 padding: 8, 
//                 zIndex: 100, 
//                 minWidth: 160,
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//               }}>
//                 <button className="btn btn-sm" style={{ width: '100%', justifyContent: 'flex-start', color: '#1877F2' }} onClick={() => handleShare('facebook')}>
//                   <FaFacebook /> Facebook
//                 </button>
//                 <button className="btn btn-sm" style={{ width: '100%', justifyContent: 'flex-start', color: '#1DA1F2' }} onClick={() => handleShare('twitter')}>
//                   <FaTwitter /> Twitter
//                 </button>
//                 <button className="btn btn-sm" style={{ width: '100%', justifyContent: 'flex-start' }} onClick={() => handleShare('copy')}>
//                   Copier le lien
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Image principale */}
//       <div className="card" style={{ marginTop: 16 }}>
//         <div className="card-body" style={{ padding: 0 }}>
//           <div style={{ position: 'relative', height: 400, background: '#000', borderRadius: '8px 8px 0 0', overflow: 'hidden' }}>
//             {(announcement.images?.length > 0 || announcement.image_url) ? (
//               <img 
//                 src={announcement.images?.length > 0 ? announcement.images[selectedImage]?.url : announcement.image_url} 
//                 alt={announcement.title} 
//                 style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
//               />
//             ) : (
//               <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#666' }}>
//                 Aucune image
//               </div>
//             )}
//             {announcement.virtual_tour_url && (
//               <button
//                 className="btn btn-primary"
//                 style={{ position: 'absolute', bottom: 16, right: 16 }}
//                 onClick={() => setShowVirtualTour(true)}
//               >
//                 <FiMaximize /> Visite virtuelle 360°
//               </button>
//             )}
//             <div style={{ position: 'absolute', top: 12, left: 12, background: 'rgba(0,0,0,0.6)', color: '#fff', borderRadius: 20, padding: '4px 12px', fontSize: 13 }}>
//               <FiEye size={12} /> {announcement.views_count || 0} vues
//             </div>
//           </div>
          
//           {/* Miniatures */}
//           {announcement.images?.length > 1 && (
//             <div style={{ display: 'flex', gap: 8, padding: 12, overflowX: 'auto' }}>
//               {announcement.images.map((img, i) => (
//                 <img 
//                   key={i} 
//                   src={img.url} 
//                   alt="" 
//                   onClick={() => setSelectedImage(i)}
//                   style={{ 
//                     width: 80, 
//                     height: 60, 
//                     objectFit: 'cover', 
//                     borderRadius: 4, 
//                     cursor: 'pointer', 
//                     border: selectedImage === i ? '2px solid var(--primary)' : '2px solid transparent' 
//                   }} 
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modal visite virtuelle */}
//       {showVirtualTour && (
//         <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 2000, display: 'flex', flexDirection: 'column' }}>
//           <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 16px', color: '#fff' }}>
//             <h3>Visite virtuelle — {announcement.title}</h3>
//             <button onClick={() => setShowVirtualTour(false)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 24 }}>
//               <FiX />
//             </button>
//           </div>
//           <iframe
//             src={announcement.virtual_tour_url}
//             style={{ flex: 1, border: 'none' }}
//             allowFullScreen
//             allow="xr-spatial-tracking; gyroscope; accelerometer"
//             title="Visite virtuelle"
//           />
//         </div>
//       )}

//       {/* Contenu principal */}
//       <div className="grid-2" style={{ marginTop: 16 }}>
//         {/* Colonne gauche */}
//         <div>
//           <div className="card">
//             <div className="card-header"><h2>Informations</h2></div>
//             <div className="card-body">
//               <div className="detail-row">
//                 <div className="detail-label">Prix</div>
//                 <div className="detail-value" style={{ fontSize: 20, fontWeight: 700, color: 'var(--primary)' }}>
//                   {parseInt(announcement.price || 0).toLocaleString()} XOF{announcement.transaction_type === 'rent' ? '/mois' : ''}
//                 </div>
//               </div>
//               <div className="detail-row">
//                 <div className="detail-label">Type</div>
//                 <div className="detail-value">{announcement.property_type || '-'}</div>
//               </div>
//               <div className="detail-row">
//                 <div className="detail-label">Transaction</div>
//                 <div className="detail-value">
//                   <span className={`badge badge-${announcement.transaction_type === 'rent' ? 'info' : 'success'}`}>
//                     {announcement.transaction_type === 'rent' ? 'Location' : 'Vente'}
//                   </span>
//                 </div>
//               </div>
//               {announcement.surface_area && (
//                 <div className="detail-row">
//                   <div className="detail-label">Surface</div>
//                   <div className="detail-value">{announcement.surface_area} m²</div>
//                 </div>
//               )}
//               {announcement.num_rooms && (
//                 <div className="detail-row">
//                   <div className="detail-label">Pièces</div>
//                   <div className="detail-value"><FaBed size={14} /> {announcement.num_rooms}</div>
//                 </div>
//               )}
//               <div className="detail-row">
//                 <div className="detail-label">Ville</div>
//                 <div className="detail-value"><FiMapPin size={14} /> {announcement.city || '-'}</div>
//               </div>
//               {announcement.neighborhood && (
//                 <div className="detail-row">
//                   <div className="detail-label">Quartier</div>
//                   <div className="detail-value">{announcement.neighborhood}</div>
//                 </div>
//               )}
//               {announcement.address && (
//                 <div className="detail-row">
//                   <div className="detail-label">Adresse</div>
//                   <div className="detail-value">{announcement.address}</div>
//                 </div>
//               )}
//             </div>
//           </div>
          
//           {announcement.description && (
//             <div className="card" style={{ marginTop: 16 }}>
//               <div className="card-header"><h2>Description</h2></div>
//               <div className="card-body">
//                 <p style={{ lineHeight: 1.7 }}>{announcement.description}</p>
//               </div>
//             </div>
//           )}
          
//           {announcement.videos && announcement.videos.length > 0 && (
//             <div className="card" style={{ marginTop: 16 }}>
//               <div className="card-header"><h2>Vidéo</h2></div>
//               <div className="card-body">
//                 {announcement.videos.map((video, idx) => {
//                   if (!video || !video.url) return null;
//                   let embedUrl = video.url;
//                   // Handle simple YouTube links
//                   if (embedUrl.includes('youtube.com/watch?v=')) {
//                     embedUrl = embedUrl.replace('watch?v=', 'embed/');
//                     const ampersandPos = embedUrl.indexOf('&');
//                     if (ampersandPos !== -1) {
//                       embedUrl = embedUrl.substring(0, ampersandPos);
//                     }
//                   } else if (embedUrl.includes('youtu.be/')) {
//                     embedUrl = embedUrl.replace('youtu.be/', 'youtube.com/embed/');
//                     const queryPos = embedUrl.indexOf('?');
//                     if (queryPos !== -1) {
//                       embedUrl = embedUrl.substring(0, queryPos);
//                     }
//                   }
                  
//                   return (
//                     <div key={video.id || idx} style={{ marginBottom: 16 }}>
//                       {embedUrl.includes('youtube.com/embed') ? (
//                         <iframe 
//                           width="100%" 
//                           height="315" 
//                           src={embedUrl} 
//                           title="YouTube video player" 
//                           frameBorder="0" 
//                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
//                           allowFullScreen
//                         ></iframe>
//                       ) : (
//                         <a href={video.url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
//                           <FiVideo /> Voir la vidéo
//                         </a>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Colonne droite */}
//         <div>
//           {announcement.latitude && announcement.longitude && (
//             <div className="card" style={{ marginBottom: 16 }}>
//               <div className="card-header"><h2><FiMapPin /> Localisation</h2></div>
//               <div style={{ height: 250, borderRadius: '0 0 8px 8px', overflow: 'hidden' }}>
//                 <MapContainer 
//                   center={[parseFloat(announcement.latitude), parseFloat(announcement.longitude)]} 
//                   zoom={15} 
//                   style={{ height: '100%', width: '100%' }}
//                 >
//                   <TileLayer 
//                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
//                     attribution='&copy; OpenStreetMap contributors' 
//                   />
//                   <Marker position={[parseFloat(announcement.latitude), parseFloat(announcement.longitude)]}>
//                     <Popup>
//                       <strong>{announcement.title}</strong><br />
//                       {announcement.address || announcement.city}
//                     </Popup>
//                   </Marker>
//                 </MapContainer>
//               </div>
//             </div>
//           )}
          
//           {/* Formulaire de contact */}
//           <div className="card">
//             <div className="card-header"><h2>Contacter l'agence</h2></div>
//             <div className="card-body">
//               {contactSent ? (
//                 <div style={{ textAlign: 'center', padding: 24, color: 'var(--success)' }}>
//                   <FiMail size={32} />
//                   <p>Votre demande a été envoyée ! Un agent vous contactera sous 24h.</p>
//                 </div>
//               ) : (
//                 <form onSubmit={handleContact}>
//                   <div className="form-group">
//                     <label>Nom *</label>
//                     <input 
//                       className="form-control" 
//                       value={contactForm.name} 
//                       onChange={e => setContactForm({ ...contactForm, name: e.target.value })} 
//                       required 
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Email</label>
//                     <input 
//                       type="email" 
//                       className="form-control" 
//                       value={contactForm.email} 
//                       onChange={e => setContactForm({ ...contactForm, email: e.target.value })} 
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Téléphone</label>
//                     <input 
//                       className="form-control" 
//                       value={contactForm.phone} 
//                       onChange={e => setContactForm({ ...contactForm, phone: e.target.value })} 
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Message</label>
//                     <textarea 
//                       className="form-control" 
//                       rows={3} 
//                       value={contactForm.message} 
//                       onChange={e => setContactForm({ ...contactForm, message: e.target.value })} 
//                       placeholder="Je suis intéressé par ce bien..." 
//                     />
//                   </div>
//                   <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
//                     Envoyer la demande
//                   </button>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Statistiques (agents seulement) */}
//       {isAgent && stats && (
//         <div className="card" style={{ marginTop: 16 }}>
//           <div className="card-header"><h2><FiBarChart2 /> Statistiques de consultation</h2></div>
//           <div className="card-body">
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 16 }}>
//               <div style={{ textAlign: 'center', padding: 16, background: 'var(--bg)', borderRadius: 8 }}>
//                 <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--primary)' }}>{stats.views_count || 0}</div>
//                 <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}><FiEye size={12} /> Vues totales</div>
//               </div>
//               <div style={{ textAlign: 'center', padding: 16, background: 'var(--bg)', borderRadius: 8 }}>
//                 <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--success)' }}>{stats.contact_requests_count || 0}</div>
//                 <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}><FiUsers size={12} /> Demandes de contact</div>
//               </div>
//               <div style={{ textAlign: 'center', padding: 16, background: 'var(--bg)', borderRadius: 8 }}>
//                 <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--warning)' }}>{stats.shares_count || 0}</div>
//                 <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}><FiShare2 size={12} /> Partages</div>
//               </div>
//             </div>
            
//             {stats.contacts_by_day?.length > 0 && (
//               <div>
//                 <h4 style={{ marginBottom: 8 }}>Contacts par jour (30 derniers jours)</h4>
//                 <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 80 }}>
//                   {stats.contacts_by_day.slice(0, 14).reverse().map((d, i) => {
//                     const maxCount = Math.max(...stats.contacts_by_day.map(x => parseInt(x.count)));
//                     const height = maxCount > 0 ? (parseInt(d.count) / maxCount) * 70 : 0;
//                     return (
//                       <div 
//                         key={i} 
//                         title={`${d.date}: ${d.count} contact(s)`} 
//                         style={{ 
//                           flex: 1, 
//                           background: 'var(--primary)', 
//                           borderRadius: '2px 2px 0 0', 
//                           height: `${height}px`, 
//                           minHeight: 2, 
//                           cursor: 'pointer' 
//                         }} 
//                       />
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Recommandations */}
//       {recommendations.length > 0 && (
//         <div className="card" style={{ marginTop: 16 }}>
//           <div className="card-header"><h2>Biens similaires recommandés</h2></div>
//           <div className="card-body">
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 }}>
//               {recommendations.map(rec => (
//                 <div 
//                   key={rec.id} 
//                   className="property-card" 
//                   style={{ cursor: 'pointer' }} 
//                   onClick={() => navigate(`/announcements/${rec.slug || rec.id}`)}
//                 >
//                   <div style={{ height: 140, background: '#eee', borderRadius: '8px 8px 0 0', overflow: 'hidden' }}>
//                     {rec.image_url ? 
//                       <img src={rec.image_url} alt={rec.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : 
//                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999' }}>Pas d'image</div>
//                     }
//                   </div>
//                   <div style={{ padding: 12 }}>
//                     <div style={{ fontWeight: 600, marginBottom: 4 }}>{rec.title}</div>
//                     <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{rec.property_type} — {rec.city}</div>
//                     <div style={{ fontWeight: 700, color: 'var(--primary)', marginTop: 4 }}>
//                       {parseInt(rec.price || 0).toLocaleString()} XOF
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AnnouncementDetailPage;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiHeart, FiShare2, FiPhone,FiHome, FiMail, FiMapPin, FiEye, FiMaximize, FiVideo, FiX, FiBarChart2, FiUsers, FiExternalLink, FiLoader, FiAlertCircle } from 'react-icons/fi';
import { FaWhatsapp, FaFacebook, FaTwitter } from 'react-icons/fa';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { announcementAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-hot-toast'; // ou votre système de notification

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const AnnouncementDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  const [showVirtualTour, setShowVirtualTour] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactForm, setContactForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [contactSent, setContactSent] = useState(false);
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [recommendations, setRecommendations] = useState([]);
  const [recLoading, setRecLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [showShareMenu, setShowShareMenu] = useState(false);
  
  // ═══ CORRECTION : vérification robuste du rôle ═══
  const isAgent = React.useMemo(() => {
    if (!user) return false;
    const roles = ['super-admin', 'admin-agence', 'admin_agence', 'agent', 'comptable', 'manager'];
    return roles.includes(user.role_slug) || roles.includes(user.role) || user.is_admin === true;
  }, [user]);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const { data } = await announcementAPI.getBySlug(slug);
        setAnnouncement(data);
        console.log('announcement',data)
        
        // SEO
        document.title = `${data.seo_title || data.title} | MaliImmo`;
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) { 
          meta = document.createElement('meta'); 
          meta.name = 'description'; 
          document.head.appendChild(meta); 
        }
        meta.content = data.seo_description || data.description?.substring(0, 160) || '';
        
        // ═══ CORRECTION : chargement parallèle avec gestion d'erreur visible ═══
        if (data?.id) {
          // Stats (agents seulement)
          if (isAgent) {
            setStatsLoading(true);
            announcementAPI.getStats(data.id)
              .then(r => setStats(r.data))
              .catch(err => {
                console.warn('[Stats] Error:', err.response?.status, err.response?.data);
                // Ne pas bloquer l'affichage
              })
              .finally(() => setStatsLoading(false));
          }
          
          // Recommandations (tous)
          setRecLoading(true);
          announcementAPI.getRecommendations(data.id)
            .then(r => setRecommendations(r.data || []))
            .catch(err => console.warn('[Recs] Error:', err.response?.status))
            .finally(() => setRecLoading(false));
        }
      } catch (e) {
        toast.error('Annonce introuvable');
        navigate('/announcements');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug, navigate, isAgent]);

  // ... reste des handlers inchangés ...
   const handleToggleFavorite = async () => {
    try {
      if (isFavorite) { 
        await announcementAPI.removeFavorite(announcement.id); 
        setIsFavorite(false); 
      } else { 
        await announcementAPI.addFavorite(announcement.id); 
        setIsFavorite(true); 
      }
    } catch (e) {}
  };

  const handleShare = async (platform) => {
    const url = window.location.href;
    const text = `${announcement.title} - ${parseInt(announcement.price || 0).toLocaleString()} XOF - ${announcement.city}`;
    await announcementAPI.incrementShares(announcement.id).catch(() => {});
    
    const urls = {
      whatsapp: `https://wa.me/?text=${encodeURIComponent(text + '\n' + url)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
    };
    
    if (platform === 'copy') { 
      navigator.clipboard.writeText(url); 
      alert('Lien copié !'); 
    } else {
      window.open(urls[platform], '_blank');
    }
    setShowShareMenu(false);
  };

  const handleContact = async (e) => {
    e.preventDefault();
    try {
      const { data } = await announcementAPI.addContact(announcement.id, contactForm);
      setContactSent(true);
      // Gérer la notification côté visiteur (toast)
      if (data.notifications && data.notifications.length > 0) {
        alert("L'agence a été notifiée de votre demande en temps réel !");
      }
    } catch (e) { 
      alert("Erreur lors de l'envoi"); 
    }
  };

  if (loading) {
    return (
      <div className="container" style={{ padding: '16px 0' }}>
        <style>{`
          @keyframes shimmer {
            0% { background-position: -800px 0; }
            100% { background-position: 800px 0; }
          }
          .skeleton-block {
            background: linear-gradient(90deg, var(--bg-secondary, #f0f0f0) 25%, var(--bg-card, #e8e8e8) 50%, var(--bg-secondary, #f0f0f0) 75%);
            background-size: 800px 100%;
            animation: shimmer 1.6s infinite linear;
            border-radius: 8px;
          }
        `}</style>

        {/* Header skeleton */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <div className="skeleton-block" style={{ width: 90, height: 34 }} />
          <div className="skeleton-block" style={{ width: 280, height: 28, flex: 1, maxWidth: 400 }} />
          <div className="skeleton-block" style={{ width: 100, height: 34, marginLeft: 'auto' }} />
          <div className="skeleton-block" style={{ width: 120, height: 34 }} />
        </div>

        {/* Hero image skeleton */}
        <div className="skeleton-block" style={{ width: '100%', height: 420, borderRadius: 12, marginBottom: 20 }} />

        {/* Thumbnails row */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {[1,2,3,4,5].map(i => <div key={i} className="skeleton-block" style={{ width: 80, height: 56, flexShrink: 0 }} />)}
        </div>

        {/* Main grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: 20 }}>
          {/* Left col */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 24, border: '1px solid var(--border-color)' }}>
              <div className="skeleton-block" style={{ width: 160, height: 20, marginBottom: 20 }} />
              {[1,2,3,4].map(i => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
                  <div className="skeleton-block" style={{ width: 100, height: 14 }} />
                  <div className="skeleton-block" style={{ width: 160, height: 14 }} />
                </div>
              ))}
            </div>
            <div style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 24, border: '1px solid var(--border-color)' }}>
              <div className="skeleton-block" style={{ width: 120, height: 20, marginBottom: 16 }} />
              {[1,2,3,4,5,6].map(i => <div key={i} className="skeleton-block" style={{ width: '100%', height: 14, marginBottom: 10 }} />)}
            </div>
          </div>

          {/* Right col */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div className="skeleton-block" style={{ height: 260, borderRadius: 12 }} />
            <div style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 24, border: '1px solid var(--border-color)' }}>
              <div className="skeleton-block" style={{ width: 180, height: 20, marginBottom: 20 }} />
              {[1,2,3].map(i => <div key={i} className="skeleton-block" style={{ width: '100%', height: 40, marginBottom: 12, borderRadius: 8 }} />)}
              <div className="skeleton-block" style={{ width: '100%', height: 80, borderRadius: 8, marginBottom: 12 }} />
              <div className="skeleton-block" style={{ width: '100%', height: 42, borderRadius: 8 }} />
            </div>
          </div>
        </div>

        {/* Floating label */}
        <div style={{ textAlign: 'center', padding: '32px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, color: 'var(--text-secondary)' }}>
          <FiLoader size={18} className="spin" />
          <span style={{ fontSize: 14, fontStyle: 'italic' }}>Chargement de l'annonce en cours…</span>
        </div>
      </div>
    );
  }

  if (!announcement) return null;

  return (
    <div className="container" style={{ padding: '16px 0' }}>
      {/* Header */}
      <div className="page-header" style={{ flexWrap: 'wrap', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/announcements')}>
            <FiArrowLeft /> Retour
          </button>
          <h1 style={{ margin: 0, fontSize: 'clamp(18px, 3vw, 28px)' }}>{announcement.title}</h1>
          {announcement.is_featured && <span className="badge badge-warning">⭐ Vedette</span>}
          <span className={`badge badge-${announcement.status === 'published' ? 'success' : 'secondary'}`}>
            {announcement.status === 'published' ? 'Publié' : 'Brouillon'}
          </span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className={`btn btn-sm ${isFavorite ? 'btn-danger' : 'btn-secondary'}`} onClick={handleToggleFavorite}>
            <FiHeart fill={isFavorite ? 'currentColor' : 'none'} /> {isFavorite ? 'Favori' : 'Favoris'}
          </button>
          <button className="btn btn-success btn-sm" style={{ background: '#25D366', borderColor: '#25D366', color: '#fff' }} onClick={() => handleShare('whatsapp')}>
            <FaWhatsapp /> WhatsApp
          </button>
          <div style={{ position: 'relative' }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setShowShareMenu(!showShareMenu)}>
              <FiShare2 /> Partager
            </button>
            {showShareMenu && (
              <div className="dropdown-menu" style={{ right: 0, left: 'auto', minWidth: 180 }}>
                <button className="dropdown-item" onClick={() => handleShare('facebook')}><FaFacebook style={{ color: '#1877F2' }} /> Facebook</button>
                <button className="dropdown-item" onClick={() => handleShare('twitter')}><FaTwitter style={{ color: '#1DA1F2' }} /> Twitter</button>
                <button className="dropdown-item" onClick={() => handleShare('copy')}><FiExternalLink /> Copier le lien</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Image principale */}
      <div className="card" style={{ marginTop: 16, overflow: 'hidden' }}>
        <div style={{ position: 'relative', height: 420, background: '#000', overflow: 'hidden' }}>
          {(announcement.images?.length > 0 || announcement.image_url) ? (
            <img 
              src={announcement.images?.length > 0 ? announcement.images[selectedImage]?.url : announcement.image_url} 
              alt={announcement.title} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
            />
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#666' }}>
              <FiHome size={48} />
            </div>
          )}
          
          {announcement.virtual_tour_url && (
            <button className="btn btn-primary" style={{ position: 'absolute', bottom: 16, right: 16, display: 'flex', alignItems: 'center', gap: 6 }} onClick={() => setShowVirtualTour(true)}>
              <FiMaximize /> Visite 360°
            </button>
          )}
          
          <div style={{ position: 'absolute', top: 12, left: 12, background: 'rgba(0,0,0,0.7)', color: '#fff', borderRadius: 20, padding: '6px 14px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <FiEye size={14} /> {announcement.views_count || 0} vues
          </div>
          
          {/* Compteur d'images */}
          {announcement.images?.length > 1 && (
            <div style={{ position: 'absolute', bottom: 16, left: 16, background: 'rgba(0,0,0,0.6)', color: '#fff', borderRadius: 20, padding: '4px 12px', fontSize: 12 }}>
              {selectedImage + 1} / {announcement.images.length}
            </div>
          )}
        </div>
        
        {/* Miniatures */}
        {announcement.images?.length > 1 && (
          <div style={{ display: 'flex', gap: 8, padding: 12, overflowX: 'auto', background: '#f8f9fa' }}>
            {announcement.images.map((img, i) => (
              <img 
                key={i} 
                src={img.url} 
                alt="" 
                onClick={() => setSelectedImage(i)}
                style={{ 
                  width: 80, height: 60, objectFit: 'cover', borderRadius: 6, cursor: 'pointer',
                  border: selectedImage === i ? '3px solid var(--primary)' : '3px solid transparent',
                  opacity: selectedImage === i ? 1 : 0.7,
                  transition: 'all 0.2s'
                }} 
              />
            ))}
          </div>
        )}
      </div>

      {/* ═══ GRID PRINCIPAL ═══ */}
      <div className="grid-2" style={{ marginTop: 20, gap: 20 }}>
        {/* Colonne gauche */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Infos */}
          <div className="card">
            <div className="card-header"><h2>Informations</h2></div>
            <div className="card-body">
              <div className="detail-row">
                <div className="detail-label">Prix</div>
                <div className="detail-value" style={{ fontSize: 24, fontWeight: 700, color: 'var(--primary)' }}>
                  {parseInt(announcement.price || 0).toLocaleString('fr-FR')} XOF{announcement.transaction_type === 'rent' ? '/mois' : ''}
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-label">Type</div>
                <div className="detail-value">{announcement.property_type || '-'}</div>
              </div>
              <div className="detail-row">
                <div className="detail-label">Transaction</div>
                <div className="detail-value">
                  <span className={`badge badge-${announcement.transaction_type === 'rent' ? 'info' : 'success'}`}>
                    {announcement.transaction_type === 'rent' ? 'Location' : 'Vente'}
                  </span>
                </div>
              </div>
              {announcement.surface_area && (
                <div className="detail-row">
                  <div className="detail-label">Surface</div>
                  <div className="detail-value">{announcement.surface_area} m²</div>
                </div>
              )}
              {announcement.num_rooms && (
                <div className="detail-row">
                  <div className="detail-label">Pièces</div>
                  <div className="detail-value">{announcement.num_rooms} chambre(s)</div>
                </div>
              )}
              <div className="detail-row">
                <div className="detail-label">Localisation</div>
                <div className="detail-value">
                  <FiMapPin size={14} style={{ marginRight: 4 }} />
                  {[announcement.address, announcement.neighborhood, announcement.city].filter(Boolean).join(', ')}
                </div>
              </div>
            </div>
          </div>
          
          {/* Description */}
          {announcement.description && (
            <div className="card">
              <div className="card-header"><h2>Description</h2></div>
              <div className="card-body">
                <p style={{ lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{announcement.description}</p>
              </div>
            </div>
          )}
          
          {/* Vidéos */}
          {announcement.videos && announcement.videos.length > 0 && (
            <div className="card">
              <div className="card-header"><h2>Vidéos</h2></div>
              <div className="card-body">
                {announcement.videos.map((video, idx) => {
                  if (!video?.url) return null;
                  let embedUrl = video.url;
                  if (embedUrl.includes('youtube.com/watch?v=')) {
                    embedUrl = embedUrl.replace('watch?v=', 'embed/').split('&')[0];
                  } else if (embedUrl.includes('youtu.be/')) {
                    embedUrl = embedUrl.replace('youtu.be/', 'youtube.com/embed/').split('?')[0];
                  }
                  return embedUrl.includes('youtube.com/embed') ? (
                    <div key={video.id || idx} style={{ marginBottom: 16, borderRadius: 8, overflow: 'hidden' }}>
                      <iframe width="100%" height="360" src={embedUrl} title={video.title} frameBorder="0" allowFullScreen />
                    </div>
                  ) : (
                    <a key={video.id || idx} href={video.url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FiVideo /> Voir la vidéo
                    </a>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Colonne droite */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Carte */}
          {announcement.latitude && announcement.longitude && (
            <div className="card">
              <div className="card-header"><h2><FiMapPin /> Localisation</h2></div>
              <div style={{ height: 280, borderRadius: '0 0 8px 8px', overflow: 'hidden' }}>
                <MapContainer center={[parseFloat(announcement.latitude), parseFloat(announcement.longitude)]} zoom={15} style={{ height: '100%', width: '100%' }}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OSM' />
                  <Marker position={[parseFloat(announcement.latitude), parseFloat(announcement.longitude)]}>
                    <Popup><strong>{announcement.title}</strong><br />{announcement.address || announcement.city}</Popup>
                  </Marker>
                </MapContainer>
              </div>
            </div>
          )}
          
          {/* Contact */}
          <div className="card">
            <div className="card-header"><h2>Contacter l'agence</h2></div>
            <div className="card-body">
              {contactSent ? (
                <div style={{ textAlign: 'center', padding: 32 }}>
                  <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--success-light)', color: 'var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <FiMail size={28} />
                  </div>
                  <h3 style={{ marginBottom: 8 }}>Demande envoyée !</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>Un agent vous contactera sous 24h.</p>
                </div>
              ) : (
                <form onSubmit={handleContact}>
                  <div className="form-group"><label>Nom *</label><input className="form-control" value={contactForm.name} onChange={e => setContactForm({ ...contactForm, name: e.target.value })} required /></div>
                  <div className="form-group"><label>Email</label><input type="email" className="form-control" value={contactForm.email} onChange={e => setContactForm({ ...contactForm, email: e.target.value })} /></div>
                  <div className="form-group"><label>Téléphone</label><input className="form-control" value={contactForm.phone} onChange={e => setContactForm({ ...contactForm, phone: e.target.value })} /></div>
                  <div className="form-group"><label>Message</label><textarea className="form-control" rows={3} value={contactForm.message} onChange={e => setContactForm({ ...contactForm, message: e.target.value })} placeholder="Je suis intéressé par ce bien..." /></div>
                  <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Envoyer la demande</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ═══ STATS AGENT (avec skeleton loader) ═══ */}
      {isAgent && (
        <div className="card" style={{ marginTop: 20 }}>
          <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2><FiBarChart2 /> Statistiques de consultation</h2>
            {statsLoading && <FiLoader className="spin" size={18} style={{ color: 'var(--primary)' }} />}
          </div>
          <div className="card-body">
            {statsLoading && !stats ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                {[1,2,3].map(i => <div key={i} style={{ height: 100, background: '#f0f0f0', borderRadius: 8, animation: 'pulse 1.5s infinite' }} />)}
              </div>
            ) : stats ? (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 24 }}>
                  <StatCard icon={<FiEye />} label="Vues totales" value={stats.views_count || 0} color="primary" />
                  <StatCard icon={<FiUsers />} label="Demandes de contact" value={stats.contact_requests_count || 0} color="success" />
                  <StatCard icon={<FiShare2 />} label="Partages" value={stats.shares_count || 0} color="warning" />
                </div>
                
                {stats.contacts_by_day?.length > 0 && (
                  <div>
                    <h4 style={{ marginBottom: 12, fontSize: 14 }}>Contacts par jour (30 derniers jours)</h4>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 100, padding: '0 4px' }}>
                      {stats.contacts_by_day.slice(0, 14).reverse().map((d, i) => {
                        const maxCount = Math.max(...stats.contacts_by_day.map(x => parseInt(x.count)), 1);
                        const height = (parseInt(d.count) / maxCount) * 90;
                        return (
                          <div key={i} title={`${d.date}: ${d.count} contact(s)`} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                            <div style={{ width: '100%', background: 'var(--primary)', borderRadius: '4px 4px 0 0', height: `${Math.max(height, 4)}px`, minHeight: 4, transition: 'height 0.3s' }} />
                            <span style={{ fontSize: 9, color: '#999', transform: 'rotate(-45deg)', transformOrigin: 'top left', whiteSpace: 'nowrap' }}>{d.date.slice(5)}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: 24, color: 'var(--text-secondary)' }}>
                <FiAlertCircle size={24} style={{ marginBottom: 8 }} />
                <p>Statistiques indisponibles</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ═══ RECOMMANDATIONS (avec skeleton) ═══ */}
      <div className="card" style={{ marginTop: 20 }}>
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>Biens similaires</h2>
          {recLoading && <FiLoader className="spin" size={18} style={{ color: 'var(--primary)' }} />}
        </div>
        <div className="card-body">
          {recLoading && recommendations.length === 0 ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 }}>
              {[1,2,3].map(i => <div key={i} style={{ height: 200, background: '#f0f0f0', borderRadius: 8, animation: 'pulse 1.5s infinite' }} />)}
            </div>
          ) : recommendations.length > 0 ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
              {recommendations.map(rec => (
                <div key={rec.id} className="property-card-hover" onClick={() => navigate(`/announcements/${rec.slug || rec.id}`)} style={{ cursor: 'pointer', borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border)', transition: 'transform 0.2s, box-shadow 0.2s' }}>
                  <div style={{ height: 160, background: '#eee', overflow: 'hidden' }}>
                    {rec.image_url ? <img src={rec.image_url} alt={rec.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }} /> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999' }}>Pas d'image</div>}
                  </div>
                  <div style={{ padding: 16 }}>
                    <div style={{ fontWeight: 600, marginBottom: 6, fontSize: 15 }}>{rec.title}</div>
                    <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>{rec.property_type} — {rec.city}</div>
                    <div style={{ fontWeight: 700, color: 'var(--primary)', fontSize: 16 }}>{parseInt(rec.price || 0).toLocaleString('fr-FR')} XOF</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: 24 }}>Aucune recommandation disponible</p>
          )}
        </div>
      </div>

      {/* Modal visite virtuelle */}
      {showVirtualTour && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', color: '#fff' }}>
            <h3 style={{ margin: 0 }}>Visite virtuelle — {announcement.title}</h3>
            <button onClick={() => setShowVirtualTour(false)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 24 }}><FiX /></button>
          </div>
          <iframe src={announcement.virtual_tour_url} style={{ flex: 1, border: 'none' }} allowFullScreen title="Visite virtuelle" />
        </div>
      )}
    </div>
  );
};

// ═══ SOUS-COMPOSANT STAT CARD ═══
const StatCard = ({ icon, label, value, color }) => (
  <div style={{ textAlign: 'center', padding: 20, background: `var(--${color}-light, #f0f9ff)`, borderRadius: 12, border: `1px solid var(--${color}-border, #e0f2fe)` }}>
    <div style={{ fontSize: 24, marginBottom: 8, color: `var(--${color})` }}>{icon}</div>
    <div style={{ fontSize: 28, fontWeight: 700, color: `var(--${color})` }}>{value.toLocaleString('fr-FR')}</div>
    <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}>{label}</div>
  </div>
);

export default AnnouncementDetailPage;